import React from "react";

const LoadingFallback = () => (
  <div className="flex justify-center items-center min-h-screen bg-[rgb(244,244,234)]">
    <div className="animate-spin rounded-full h-16 w-16 border-t-4 border-b-4 border-black"></div>
  </div>
);

export default LoadingFallback;
